// extracted by mini-css-extract-plugin
export default {"PaginationComponentDiv":"PaginationComponent_PaginationComponentDiv__69plF","active":"PaginationComponent_active__ZM5tg","pageSelect":"PaginationComponent_pageSelect__W7jCY"};